import {FontAwesomeIcon as Icon} from '@fortawesome/react-fontawesome'
import {EquipmentFlag, Vehicle} from 'domain-models'
import {hasFlag} from 'filters'
import {useCodes} from 'hooks/StateHooks'
import _ from 'lodash'
import React from 'react'
import Trans from '../../../../../components/Trans'

type VehicleEquipmentProps = {
  vehicle: Vehicle
}

class Equipment extends React.Component<VehicleEquipmentProps> {
  render() {
    const codes = useCodes()
    const flags = _.filter(codes.EquipmentFlags, (flag: EquipmentFlag) => {
      return hasFlag(this.props.vehicle, flag.field, flag.value)
    })
    return (
      <div className='w-full flex flex-row flex-wrap mt-6 md:mt-0'>
        <span className='font-semibold text-lg text-gray-700 w-full'><Trans>Ausstattung</Trans></span>

        {
          _.map(flags, (flag: EquipmentFlag) => (
              <div className='w-full sm:w-1/2 lg:w-1/3' key={flag.field + flag.value}>
                <div>
                  <Icon icon='check' /> <Trans>{flag.label}</Trans>
                </div>
              </div>
            )
          )}
      </div>
    )
  }
}

export default Equipment
